import React, { useState, useEffect } from "react";
import { User, Clock, ToggleRight, ToggleLeft, BookOpen, FileText, File, Youtube } from "lucide-react";
import TopBar from "../components/TopBar";
import './css/AssignmentDetails.css';
import axios from "../axios";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";

const AssignmentDetails = ({ setSideBar, setSettingDrawer }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();

  const [assignment, setAssignments] = useState({});
  const [isCompleted, setIsCompleted] = useState(assignment.completed);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("student_token");

        const HomeworkDetails = await axios.get('student/single_homework/' + id, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setAssignments(HomeworkDetails.data);
        setIsCompleted(HomeworkDetails.data.completed);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleToggle = async () => {

    setIsCompleted(!isCompleted);
    try{
         const token = localStorage.getItem('student_token');
const set = await axios.get(`student/mark_completed/${id}/${!isCompleted}`,
  {
              headers: { Authorization: `Bearer ${token}` },

  }
);
toast.success('Homework status is changed successsfuly');
    }catch(error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    console.log("Completion status updated:", { id: assignment.id, completed: !isCompleted });
  };

  return (
    <>
      <TopBar title="Assignment Details" setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />
      {isLoading ? (
        <div className="details-container skeleton-container">
          <div className="details-header skeleton-header">
            <div className="skeleton-icon"></div>
            <div className="skeleton-title"></div>
          </div>
          <div className="details-card">
            <div className="teacher-info skeleton-teacher-info">
              <div className="skeleton-teacher-photo"></div>
              <div className="teacher-details">
                <div className="skeleton-label"></div>
                <div className="skeleton-value"></div>
              </div>
            </div>
            <div className="detail-field skeleton-field">
              <div className="skeleton-icon"></div>
              <div className="field-content">
                <div className="skeleton-label"></div>
                <div className="skeleton-value"></div>
              </div>
            </div>
            <div className="detail-field skeleton-field">
              <div className="skeleton-icon"></div>
              <div className="field-content">
                <div className="skeleton-label"></div>
                <div className="skeleton-value"></div>
              </div>
            </div>
            <div className="detail-field skeleton-field">
              <div className="skeleton-icon"></div>
              <div className="field-content">
                <div className="skeleton-label"></div>
                <div className="skeleton-description"></div>
                <div className="skeleton-description"></div>
              </div>
            </div>
            <div className="detail-field files-section skeleton-field">
              <div className="skeleton-icon"></div>
              <div className="field-content">
                <div className="skeleton-label"></div>
                <div className="skeleton-value"></div>
              </div>
            </div>
            <div className="detail-field video-section skeleton-field">
              <div className="skeleton-icon"></div>
              <div className="field-content">
                <div className="skeleton-label"></div>
                <div className="skeleton-video"></div>
              </div>
            </div>
            <div className="detail-field skeleton-field">
              <div className="skeleton-icon"></div>
              <div className="field-content">
                <div className="skeleton-label"></div>
                <div className="skeleton-toggle"></div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="details-container">
          <div className="details-header">
            <BookOpen size={20} className="header-icon" />
            <h2>{assignment.title}</h2>
          </div>
          <div className="details-card">
            <div className="teacher-info">
              <img src={assignment.teacherPhoto} alt="Teacher" className="teacher-photo" />
              <div className="teacher-details">
                <span className="field-label">Teacher</span>
                <span className="field-value">{assignment.teacherName}</span>
              </div>
            </div>
            <div className="detail-field">
              <div className="field-icon">
                <BookOpen size={18} />
              </div>
              <div className="field-content">
                <span className="field-label">Title</span>
                <span className="field-value">{assignment.title}</span>
              </div>
            </div>
            <div className="detail-field">
              <div className="field-icon">
                <Clock size={18} />
              </div>
              <div className="field-content">
                <span className="field-label">Date</span>
                <span className="field-value">{assignment.dueDate}</span>
              </div>
            </div>
            <div className="detail-field">
              <div className="field-icon">
                <FileText size={18} />
              </div>
              <div className="field-content">
                <span className="field-label">Description</span>
                <p className="field-description">{assignment.description}</p>
              </div>
            </div>
            <div className="detail-field files-section">
              <div className="field-icon">
                <File size={18} />
              </div>
              <div className="field-content">
                <span className="field-label">Uploaded Files</span>
                {assignment.files?.length > 0 ? (
                  <ul className="file-list">
                    {assignment.files.map((file, index) => (
                      <li key={index}>
                        <a href={file.url} target="_blank" rel="noopener noreferrer" className="file-link">
                          <File size={16} className="file-icon" /> {file.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span className="field-value">No files uploaded</span>
                )}
              </div>
            </div>
            <div className="detail-field video-section">
              <div className="field-icon">
                <Youtube size={18} />
              </div>
              <div className="field-content">
                <span className="field-label">YouTube Video</span>
                {assignment.youtubeVideo ? (
                  <div className="video-wrapper">
                    <iframe
                      src={assignment.youtubeVideo}
                      title="Assignment Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                ) : (
                  <span className="field-value">No video available</span>
                )}
              </div>
            </div>
            <div className="detail-field">
              <div className="field-icon">
                {isCompleted ? <ToggleRight size={18} /> : <ToggleLeft size={18} />}
              </div>
              <div className="field-content">
                <span className="field-label">Status</span>
                <div className="toggle-wrapper">
                  <span className="field-value">{isCompleted ? "Completed" : "Pending"}</span>
                  <button className="toggle-button" onClick={handleToggle}>
                    {isCompleted ? "Mark as Pending" : "Mark as Completed"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssignmentDetails;